//booking widget variables
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0;
var opencheck;


// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	//main menu submenus
	if(document.getElementsByClassName('submenu').length > 0){
		let allMainLinks = document.getElementById('primary-nav').getElementsByTagName('a');
		for(let i = 0; i < allMainLinks.length; i++){
			allMainLinks[i].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					e.preventDefault();
					if(this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.remove('open')
					} else {
						this.nextElementSibling.classList.add('open')
					}
				}
			})
		}
	}


	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

	}); 
 
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		    /* Initialize Parallax Lybrary */
			// let istouch = document.querySelector('.mod-no-touchevents')
			// if ($(window).width() > 767) {
			// 	if (istouch) {
			// 		var sk = skrollr.init();
			// 	}
			// }
	

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		//Burger menu open close
		let btnBurger = document.querySelector('.menu-burger');
		btnBurger.addEventListener('click' , ()=>{
			document.querySelector('.container-navigation').classList.toggle('open');
		})

		document.querySelector('.close-navigation').addEventListener('click' , ()=>{
			document.querySelector('.container-navigation').classList.remove('open');
		})
		//Booking open close

		document.querySelector('.btn-booking').addEventListener('click' , (e)=>{
			e.preventDefault();
			document.querySelector('.booking-block').classList.toggle('open');
		})

		document.querySelector('.js-booking-close').addEventListener('click' , ()=>{
			document.querySelector('.booking-block').classList.remove('open');
		})

		//HEADER BLUE FIXED
		let bodyElm = document.querySelector('body')
		if( bodyElm.classList.contains('gallery') || bodyElm.classList.contains('sitemap') ){
			document.querySelector('.header').classList.add('no-hero');
		}
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



/** BOOKING WIDGET FUNCTIONALITY */


$(document).ready(function () {

	//To create after event 
	$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {
		$.datepicker._updateDatepicker_original(inst);
		var afterShow = this._get(inst, 'afterShow');
		if (afterShow)
			afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
	}
	$('#arriveInput').on('change', function(){
		start = $(this).val();
		$('.calendar-block').datepicker("setDate", start)
	})
	$('#departureInput').on('change', function(){
		end = $(this).val();
		$('.calendar-block').datepicker("setDate", end)
	})
	//alert($('#arriveInput').val());
	let fullMonths = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
	$('.calendar-block').datepicker({
		changeMonth: false,
		dateFormat: 'yy-mm-dd',
		numberOfMonths: 1,
		monthNamesShort: fullMonths,
		//altField: "#arriveInput",
		//altFormat: "mm-dd-yy",
		minDate: '2025-05-08',
		beforeShowDay: function (date) { 
			setTimeout(function() {
				document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
					e.setAttribute('tabindex', '-1');
				})
			}, 1000);

			$.datepicker._defaults.dateFormat = "yy-mm-dd";
			var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			if (date.getTime() == startDate.getTime()) {
				return [true, "startday"];
			} else {
				if (date.getTime() == endDate.getTime()) {
					return [true, "endday"];
				} else {
					if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
						return [true, "days"];
					} else {
						return [true, ""];
					}
				}
			}
		},
		onSelect: function (date) {
			var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

			if (opened == 0) {
				opened = 1;
				start = date;
				end = date;
				opencheck = 0;
			} else {
				opened = 0;
				if (selectedDate <= arrive) {
					end = start;
					start = date;
				} else {
					end = date;
				}
			
				
			}

			$('#arriveInput').attr('value', start);
			$('#departureInput').attr('value', end);
		
		},
		onChangeMonthYear: function () {
			opencheck = 1;
		}
	});


});
